import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMatchId } from '../../../selectors/oddsHistory';
import { getTennisEventDetails, getTennisMatchTimeline } from '../../../selectors/matchTimeline';
import { PAGES } from '../../../constants';
import { getTennisEvents } from '../../../selectors/events';
import TennisMatchDescriptionTable from './TennisMatchDescriptionTable';
import TennisMatchDetails from './TennisMatchDetails';
import TennisMatchTimeLineDetails from './TennisMatchTimelineDetails';
import { getTennisMatchTimelineEvents, getTimezone } from '../../../selectors/common';
import { aGetTennisMatchTimelineRequest } from '../../../reducers';
import { aClearTennisMatchTimeline } from '../../../reducers/matchTimeline';

const mapToProps = (state) => ({
  events: getTennisEvents(state),
  matchId: getMatchId(state),
  eventDetails: getTennisEventDetails(state),
  matchTimeline: getTennisMatchTimeline(state),
  getTimezone: getTimezone(state),
  tennisMatchTimelineEvents: getTennisMatchTimelineEvents(state),

});

const actionsToProps = (dispatch) => ({
  getMatchTimeline: (payload) => dispatch(aGetTennisMatchTimelineRequest(payload)),
  clearMatchTimeline: (payload) => dispatch(aClearTennisMatchTimeline(payload)),
});

class TennisMatchTimeline extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { pathname } = window.location;
    const matchId = parseInt(this.props.matchId || (pathname.split(`${PAGES.TENNIS_MATCH_TIMELINE}/`)[1]));
    if (matchId) {
      this.props.getMatchTimeline({
        matchId,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearMatchTimeline();
  }

  render() {
    if (this.props.eventDetails && this.props.matchTimeline) {
      return (
        <>
          <TennisMatchDescriptionTable
            eventDetails={this.props.eventDetails}
          />
          <TennisMatchDetails
            eventDetails={this.props.eventDetails}
          />
          <TennisMatchTimeLineDetails
            matchTimeLine={this.props.matchTimeline}
            timezone={this.props.getTimezone}
            tennisMatchTimelineEvents={this.props.tennisMatchTimelineEvents}
          />
        </>
      );
    }
    return null;
  }
}

export default connect(mapToProps, actionsToProps)(TennisMatchTimeline);
